import React, { useEffect, useState } from "react";
import DataTableHelper from "../../../helpers/tables/DataTableHelper";
import Columns from "./Columns";
import PreviewPDF from "../../../helpers/previewPDF";
import {
  resourcesReports,
} from "../../../helpers/backend_helper";
import { getStorageUser } from "../../../helpers/api_helper";
import { Container } from "reactstrap";
import ButtonHelper from "../../../helpers/ButtonHelper";
import * as dayjs from "dayjs";
import ReactSelect from "react-select";

const Vencimientos = () => {
  const authUser = getStorageUser();
  const [tipoReporte, setTipoReporte] = useState({ label: "Vencidos", value: 1 });
  const [pending, setPending] = useState(false);
  const [modal, setModal] = useState({ show: false, update: false });
  const [modalPdf, setModalPdf] = useState({ show: false, update: false });
  const [dataPag, setDataPag] = useState({ total: 0 });
  const [filters, setFilters] = useState({
    page: 1,
    perPage: 20,
    search: "",
    orderBy: "key",
    order: "asc",
  });
  const [items, setItems] = useState([]);

  useEffect(() => {

    setPending(true);
    const config = {
      params: {
        ...filters,
        tipoReporte: tipoReporte.value,
      },
    };
    resourcesReports("show", config, "vencimientosReport")
      .then((response) => {
        setItems(response.expiresReport);
      })
      .finally(() => setPending(false));
  }, [filters, tipoReporte]);

  const getReports = (type) => {
    let config = {
      params: {
        ...filters,
        tipoReporte: tipoReporte.value,
      },
      headers: {
        Accept:
          type == 2
            ? "application/pdf"
            : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      responseType: "blob",
    };
    resourcesReports("show", config, "vencimientosReport").then(
      (response) => {
        if (type == 1) {
          const url = URL.createObjectURL(new Blob([response]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Vencimientos.xlsx");
          document.body.appendChild(link);
          link.click();
        } else {
          let nombre = "Archivo";
          var reader = new FileReader();
          reader.readAsDataURL(response);
          reader.fileName = nombre[1] || nombre[0];
          reader.onloadend = function (name) {
            name = nombre[0];
            var base64data = reader.result;
            setModalPdf({ show: true, update: false, url: base64data });
          };
        }
      }
    );
  };

  const columns = Columns(print);
  document.title = "Vencimientos | Sistema de logística";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="col-12">
            <DataTableHelper
              filterInp={false}
              menuParent={"Reportes"}
              tittle="Vencimientos"
              columns={columns}
              items={items}
              pending={pending}
              config={dataPag}
              filters={filters}
              setFilters={setFilters}
              pagination={false}
            >
              <div className="col-md-6">
                <div className="form-label mb-0">
                  <label>Tipo reporte:</label>
                  <ReactSelect
                    className="react-select-container"
                    classNamePrefix="react-select"
                    options={[
                      { label: "Vencidos", value: 1 },
                      { label: "Por vencer en 1 mes", value: 2 },
                      { label: "Por vencer en los siguientes 3 meses", value: 3 },
                    ]}
                    value={tipoReporte}
                    onChange={(e) => setTipoReporte(e)}
                    placeholder="Selecciona el tipo de reporte"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <ButtonHelper
                    addButon={false}
                    reportButons={true}
                    actionReportButon={getReports}
                  >
                  </ButtonHelper>
                </div>
              </div>
            </DataTableHelper>
          </div>
        </Container>
        {modalPdf.show && (
          <PreviewPDF
            title="Recibo de Nómina"
            modalPdf={modalPdf}
            setModalPdf={setModalPdf}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default Vencimientos;
